import React from 'react';
import { Stack, Typography } from '@mui/material';
import { ReactComponent as LockIcon } from 'assets/LockClosed.svg';

export const MessageBox = ({ message = '', handleOpenModal, sx, showLock}) => {
  return (
    <Stack gap={1} width={1} height={52} direction="row" alignItems="center"
      sx={({ palette }) => ({
        justifyContent: 'flex-start',
        bgcolor: palette.purple,
        fontSize: '0.75rem',
        fontWeight: 600,
        mt:2,
        mb:-2,
        cursor: "pointer",
        ...sx,
        // mx:-4,
      })}
    >
      {showLock && (
        <Stack
          sx={{
            pl:2,
          }}
        >
          <LockIcon />
        </Stack>
      )}
      <Typography variant="body1" color="text.primary"
        onClick={handleOpenModal}
        component={"span"}
        sx={{
          mt:2,
          mb:2,
          pl: showLock ? 1 : 8,
        }}
      >
        {message}
      </Typography>
    </Stack>
  );
};
